import React, { useEffect, useMemo, useState } from 'react';
import { Button } from 'reactstrap';
import { faListAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import '../../../../../css/components/modalSelect.scss'
import classnames from 'classnames';
import { ModalConstructor } from '../../../../shared/components';
import { createSanitizedInnerHTML, escapeHtml } from '../../../../shared/utils/htmlSanitizer';

const ModalSelect = ({
    label,
    title,
    dataSource,
    selectedItems,
    setSelectedItems,
    keyName,
    keyValue,
    renderLabel = undefined,
    fem,
    style = {},
    multiple = true,
    selected,
    setSelected,
    btnCleanSelection=true,
    todosI18nIndice = {}
}) => {
    const [modal, setModal] = useState(false);
    const [displayedItems, setDisplayedItems] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [tmpSelectedItems, setTmpSelectedItems] = useState([]);
    const { t } = useTranslation();


    useEffect(() => {
        if(multiple) {
            if(selectedItems && selectedItems?.length > 0){
                setTmpSelectedItems(selectedItems)
            }else if(dataSource?.length > 0){
                setSelectedItems([...dataSource.map(x => x[keyValue])]);
            }
        }
    }, [multiple, selectedItems])

    useEffect(() => {
        if (dataSource?.length > 0) {
            setDisplayedItems([...dataSource]);
            if(multiple && selectedItems?.length === 0) {
                setSelectedItems([...dataSource.map(x => x[keyValue])]);
            }
        }
    }, [dataSource, selectedItems]);

    const toggle = () => {
        if(multiple){
            setTmpSelectedItems([...selectedItems]);
        }
        setModal(!modal);
    };

    const save = () => {
        if(multiple){
            setSelectedItems([...tmpSelectedItems]);
        }
        toggle();
    };

    const onChangeAll = e => {
        const { checked } = e.target;
        if (checked) {
            setTmpSelectedItems([...dataSource.map(x => x[keyValue])]);
            return;
        }

        setTmpSelectedItems([]);
    };

    const changeSelected = e => {
        const { checked, value } = e.target;

        if (checked) {
            setTmpSelectedItems([...tmpSelectedItems, value]);
            return;
        }

        setTmpSelectedItems([...tmpSelectedItems.filter(x => x !== value)]);
    };

    const search = e => {
        const { value } = e.target;
        setSearchInput(value);
        const regex = new RegExp(`.*${value}.*`, 'i');
        setDisplayedItems([...dataSource.filter(x => regex.test(x[keyName]))]);
    };

    const handleModalClosed = () => {
        setDisplayedItems([...dataSource]);
        setSearchInput('');
    };

    const clear = () => {
        if(multiple){
            setTmpSelectedItems([]);
            return;
        }

        setSelected(null)
        toggle()
    };

    const selectedName = useMemo(() => {
        const selectedItem = dataSource.find(x => x[keyValue] === selected);
        if(selectedItem){
            return (renderLabel !==
                undefined &&
                typeof renderLabel ===
                'function') ?
                renderLabel(selectedItem) : selectedItem[keyName]
        }
        return '';
    }, [dataSource, keyName, keyValue, selected])

    return (
        <div>
            <Button style={style} className="modal-select-toggle" onClick={toggle}>
                <FontAwesomeIcon icon={faListAlt} />

                {
                    multiple ? (
                        <span>{label}</span>
                    ) : ''
                }

                <span  className="text-truncate d-inline-block"
                >
                    {
                        // eslint-disable-next-line no-nested-ternary
                        multiple ? selectedItems?.length === dataSource?.length
                            ? `(${fem ? t(todosI18nIndice?.fem ? todosI18nIndice?.fem : 'Todas') : t(todosI18nIndice?.masc ? todosI18nIndice?.masc : 'Todos')})`
                            : `(${selectedItems?.length || 0})` :
                            selectedName || label
                    }
                </span>
            </Button>
            <ModalConstructor
                closeable
                closeAction
                size="md"
                title={title}
                open={modal}
                setOpen={toggle}
                onClosed={handleModalClosed}
                footer={<div className="d-flex justify-content-between align-items-center w-100">
                    {
                        btnCleanSelection ? (
                            <div>
                                <Button className="btn-generic--segundo ml-0 btn-responsivo" color="danger"
                                        onClick={clear}>
                                    {t('EstatisticaLimparSelecao')}
                                </Button>
                            </div>
                        ) : ''
                    }

                    <div className="d-flex" style={{ gap: '8px' }}>
                        {
                            multiple ? (
                                <Button className="btn-generic--primeiro ml-0 btn-responsivo" onClick={save}>
                                    {t('EstatisticaSalvar')}
                                </Button>
                            ) : ''
                        }
                        <Button className="btn-generic--segundo ml-0 btn-responsivo"
                                onClick={toggle}>{t('Cancelar')}</Button>
                    </div>
                </div>
                }
            >
                <>
                    <div className="d-flex justify-content-center aligm-items-center p-2">
                        <input
                            onChange={search}
                            value={searchInput}
                            className="form-control"
                            placeholder={t('EstatisticaBuscar')}
                        />
                    </div>
                    <ul>
                        {
                            multiple ? (
                                <li className="preto70">
                                    <div className="custom-checkbox custom-control">
                                        <input
                                            checked={tmpSelectedItems?.length === dataSource?.length}
                                            onChange={onChangeAll} type="checkbox" id="item-all"
                                               className="custom-control-input" />
                                        <label className="custom-control-label" htmlFor="item-all">
                                            {fem ? t('Todas') : t('Todos')}
                                        </label>
                                    </div>
                                </li>
                            ) : ''
                        }
                        {displayedItems &&
                            displayedItems?.length > 0 &&
                            displayedItems?.map((x, i) => (
                                <li
                                    onClick={_ => {
                                        if (!multiple) {
                                            setSelected(x[keyValue]);
                                            toggle();
                                        }
                                    }}
                                    className={classnames('preto70', {
                                        'selected': !multiple && selected === x[keyValue],
                                    })}
                                    key={x[keyValue]}>
                                    <label htmlFor={`item-${i}`}>
                                        {
                                            multiple ? (
                                                <div className="custom-checkbox custom-control">
                                                    <input
                                                        value={x[keyValue]}
                                                        checked={
                                                            tmpSelectedItems?.find(
                                                                si => si === x[keyValue],
                                                            ) || false
                                                        }
                                                        onChange={changeSelected}
                                                        type="checkbox"
                                                        id={`item-${i}`}
                                                        className="custom-control-input" />
                                                    <label className="custom-control-label"
                                                           htmlFor={`item-${i}`}></label>
                                                </div>
                                            ) : ''
                                        }
                                        <span>
                                            {escapeHtml(
                                                (renderLabel !==
                                                    undefined &&
                                                    typeof renderLabel ===
                                                    'function' &&
                                                    renderLabel(x)) ||
                                                x[keyName]
                                            )}
                                        </span>
                                    </label>
                                </li>
                            ))}
                    </ul>
                </>
            </ModalConstructor>
        </div>
    );
};

export default ModalSelect;
